import './Grain.css'

// Animated film grain + vignette laid over the whole page.
export default function Grain() {
    return (
        <div className='grain' aria-hidden='true'>
            <div className='grain-noise'></div>
            <div className='grain-vignette'></div>
        </div>
    )
}
